import {DocumentType} from '@shipwell/settlements-sdk';
import {isDefined} from 'App/utils/guard';

export const isSettlementsDocumentType = (string: string | undefined): string is DocumentType =>
  isDefined(string) && Object.values(DocumentType).includes(string as DocumentType);
